export const MULTICALL_ADDR = '0x532900593eB39ea2A920db2Da4F95aEA8C172Bc5';
export const PAIR_ADDR = '0x2f45C6Df50E7F8517dAc64943a2161bBCFBa1182';
export const FLEXIBLE_ADDR = '0x3812666Cc3582d4A25BF8cdB0781255f04D4b277';
export const LOCK_ADDR = '0xD2864a9710aEB9F57dA8fF07a2Ee966C00c7A138';
export const TOKEN_ADDR = '0x75740FC7058DA148752ef8a9AdFb73966DEb42a8'
export const ROUTER_ADDR = '0xec2f2b94465Ee0a7436beB4E38FC8Cf631ECf7DF';